import api from './api';

export const productService = {
  /**
   * Obtener todos los productos
   */
  async getProducts(params = {}) {
    try {
      const response = await api.get('/products', { params });
      return response.data;
    } catch (error) {
      console.error('Error al obtener productos:', error);
      throw error;
    }
  },

  /**
   * Búsqueda de productos para formularios (mín. 3 caracteres en servidor).
   */
  async searchForForm(query, warehouseId = null, limit = 30) {
    try {
      const params = { q: query, limit };
      if (warehouseId) params.warehouse_id = warehouseId;
      const response = await api.get('/products/search-for-form', { params });
      return response.data;
    } catch (error) {
      console.error('Error al buscar productos:', error);
      throw error;
    }
  },

  /**
   * Carga productos por ID (edición / ítems referenciados).
   */
  async batchForForm(ids, warehouseId = null) {
    try {
      const payload = { ids };
      if (warehouseId) payload.warehouse_id = warehouseId;
      const response = await api.post('/products/batch-for-form', payload);
      return response.data;
    } catch (error) {
      console.error('Error al cargar productos por lote:', error);
      throw error;
    }
  },

  /**
   * Resuelve productos por SKU o ID (importación Excel).
   */
  async resolveIdentifiersForForm(identifiers, warehouseId = null) {
    try {
      const payload = { identifiers };
      if (warehouseId) payload.warehouse_id = warehouseId;
      const response = await api.post('/products/resolve-identifiers-for-form', payload);
      return response.data;
    } catch (error) {
      console.error('Error al resolver productos:', error);
      throw error;
    }
  },
  
  /**
   * Obtener un producto por ID
   */
  async getProduct(id) {
    try {
      console.log('📡 [productService] Enviando petición GET a:', `/api/products/${id}`);
      
      const response = await api.get(`/products/${id}`);
      
      console.log('✅ [productService] Producto obtenido exitosamente');
      console.log('📦 [productService] Response.data:', response.data);
      
      return response.data;
    } catch (error) {
      console.error('❌ [productService] Error al obtener producto:', error);
      console.error('📊 [productService] Error.response:', error.response);
      throw error;
    }
  },
  
  /**
   * Crear un nuevo producto
   */
  async createProduct(data) {
    try {
      console.log('📡 [productService] Enviando petición POST a:', '/api/products');
      console.log('📦 [productService] Datos a enviar:', data);
      
      const response = await api.post('/products', data);
      
      console.log('✅ [productService] Producto creado exitosamente');
      console.log('📦 [productService] Response.data:', response.data);
      
      return response.data;
    } catch (error) {
      console.error('❌ [productService] Error al crear producto:', error);
      console.error('📊 [productService] Error.response:', error.response);
      console.error('📋 [productService] Error.response?.data:', error.response?.data);
      throw error;
    }
  },
  
  /**
   * Actualizar un producto
   */
  async updateProduct(id, data) {
    try {
      console.log('📡 [productService] Enviando petición PUT a:', `/api/products/${id}`);
      console.log('📦 [productService] Datos a enviar:', data);
      
      const response = await api.put(`/products/${id}`, data);
      
      console.log('✅ [productService] Producto actualizado exitosamente');
      console.log('📦 [productService] Response.data:', response.data);
      
      return response.data;
    } catch (error) {
      console.error('❌ [productService] Error al actualizar producto:', error);
      console.error('📊 [productService] Error.response:', error.response);
      console.error('📋 [productService] Error.response?.data:', error.response?.data);
      throw error;
    }
  },

  /**
   * Edición masiva de productos (solo super administrador)
   */
  async bulkUpdateProducts(items) {
    try {
      const response = await api.post('/products/bulk-update', { items });
      return response.data;
    } catch (error) {
      console.error('Error en edición masiva de productos:', error);
      throw error;
    }
  },

  /**
   * Borrado masivo de productos (solo sin movimientos; no recetas)
   */
  async bulkDeleteProducts(ids) {
    try {
      const response = await api.post('/products/bulk-delete', { ids });
      return response.data;
    } catch (error) {
      if (error.response?.data) {
        return error.response.data;
      }
      console.error('Error en borrado masivo de productos:', error);
      throw error;
    }
  },
  
  /**
   * Eliminar un producto
   */
  async deleteProduct(id) {
    try {
      console.log('📡 [productService] Enviando petición DELETE a:', `/api/products/${id}`);
      
      const response = await api.delete(`/products/${id}`);
      
      console.log('✅ [productService] Producto eliminado exitosamente');
      console.log('📦 [productService] Response.data:', response.data);
      
      return response.data;
    } catch (error) {
      console.error('❌ [productService] Error al eliminar producto:', error);
      console.error('📊 [productService] Error.response:', error.response);
      throw error;
    }
  },
};
